import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9947b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo-and-hamburger-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "link-text heading-6"
}
const _hoisted_6 = {
  key: 1,
  class: "unread-counter"
}
const _hoisted_7 = {
  key: 0,
  class: "request-wrapper"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 3.75V16.25M16.25 10H3.75",
    stroke: "#0551CB",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_9 = {
  key: 1,
  class: "request-wrapper"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.625 10.6875V8.71875C14.625 8.04742 14.3583 7.40359 13.8836 6.92889C13.4089 6.45418 12.7651 6.1875 12.0938 6.1875H10.9688C10.745 6.1875 10.5304 6.09861 10.3721 5.94037C10.2139 5.78214 10.125 5.56753 10.125 5.34375V4.21875C10.125 3.54742 9.85832 2.90359 9.38361 2.42889C8.90891 1.95418 8.26508 1.6875 7.59375 1.6875H6.1875M7.875 1.6875H4.21875C3.753 1.6875 3.375 2.0655 3.375 2.53125V15.4688C3.375 15.9345 3.753 16.3125 4.21875 16.3125H13.7812C14.247 16.3125 14.625 15.9345 14.625 15.4688V8.4375C14.625 6.64729 13.9138 4.9304 12.648 3.66453C11.3821 2.39866 9.66521 1.6875 7.875 1.6875Z",
    stroke: "#4B4B4B",
    "stroke-width": "1.125",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_11 = {
  key: 2,
  class: "request-wrapper"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.99995 9.99984L2.72412 2.604C8.16818 4.18734 13.3019 6.68855 17.9041 9.99984C13.3022 13.3111 8.16873 15.8123 2.72495 17.3957L4.99995 9.99984ZM4.99995 9.99984H11.25",
    stroke: "#4B4B4B",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_13 = {
  key: 3,
  class: "request-wrapper"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.75 10.625L8.75 15.625L16.25 4.375",
    stroke: "#4B4B4B",
    "stroke-width": "1.25",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewDocumentSvg = _resolveComponent("NewDocumentSvg")!
  const _component_menu_link = _resolveComponent("menu-link")!
  const _component_ArchiveSvg = _resolveComponent("ArchiveSvg")!
  const _component_ReportSvg = _resolveComponent("ReportSvg")!
  const _component_UploadSvg = _resolveComponent("UploadSvg")!
  const _component_RequestPartnerSvg = _resolveComponent("RequestPartnerSvg")!
  const _component_SettingSvg = _resolveComponent("SettingSvg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { opened: _ctx.isOpened }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isOpened)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require('@/assets/ciena-exp-logo.png'),
            alt: "logo",
            style: {"width":"174px"}
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
            'close-sidebar-menu ': true,
            'close-sidebar-menu-closed': !_ctx.isOpened,
          }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onToggleSidebar'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('onToggleSidebar')), ["enter"]))
      }, [
        _createElementVNode("img", {
          src: require('@/assets/header-back.png'),
          alt: "hamburger"
        }, null, 8, _hoisted_3)
      ], 34)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetSearchValue && _ctx.resetSearchValue(...args)))
      }, [
        _createVNode(_component_menu_link, {
          text: "EPX Engagements",
          url: "/",
          "is-opened": _ctx.isOpened
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_NewDocumentSvg)
          ]),
          _: 1
        }, 8, ["is-opened"])
      ]),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetSearchValue && _ctx.resetSearchValue(...args)))
      }, [
        _createVNode(_component_menu_link, {
          text: "EMS Engagements",
          url: "/ems-dashboard",
          "is-opened": _ctx.isOpened
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_NewDocumentSvg)
          ]),
          _: 1
        }, 8, ["is-opened"])
      ]),
      _createVNode(_component_menu_link, {
        text: "Archives",
        url: "/archive",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ArchiveSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createVNode(_component_menu_link, {
        text: "Report Dashboard",
        url: "/report",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_ReportSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createVNode(_component_menu_link, {
        text: "Bulk Behaviors",
        url: "/upload",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_UploadSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      _createElementVNode("div", {
        class: "menu-link",
        style: {"cursor":"pointer"},
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCBPPartnerMenuClick && _ctx.handleCBPPartnerMenuClick(...args)))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_RequestPartnerSvg)
        ]),
        (_ctx.isOpened)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Request to CBP/Partner"))
          : _createCommentVNode("", true),
        (_ctx.unreadRequestToPartnerCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.unreadRequestToPartnerCount), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_menu_link, {
              text: "Send a Request",
              url: "/request-partner",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_menu_link, {
              text: "Review Request",
              url: "/review-request",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_menu_link, {
              text: "Request Sent",
              url: "/request-sent",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isOpenedRequestToCbpPartnerMenu && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_menu_link, {
              text: "Approved Request",
              url: "/request-approved",
              "is-opened": _ctx.isOpened
            }, {
              icon: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["is-opened"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_menu_link, {
        text: "Settings",
        url: "/app-config",
        "is-opened": _ctx.isOpened
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_SettingSvg)
        ]),
        _: 1
      }, 8, ["is-opened"]),
      (_ctx.isLogInEnabled && _ctx.isOpened)
        ? (_openBlock(), _createElementBlock("a", {
            key: 4,
            class: "log-out-button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Log Out"))
        : _createCommentVNode("", true)
    ])
  ], 2))
}